/**
 * @file コンポーネント：執刀医詳細モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// 関数読み込み
import {
    fnConvertLineStringToHtml,
    fnGetCultureLanguage,
    fnGetSurgeonFullName,
    fnHandleApiErrors,
    fnHandleApiSuccess,
} from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalSurgeon = (props) => {
    /**
     * 執刀医情報を読み込んでモーダルコンテンツ生成
     */
    const languageCode = fnGetCultureLanguage(); // UI言語
    const [fullname, setFullname] = useState(null); // 執刀医名
    const [hospital, setHospital] = useState(null); // 所属機関
    const [href, setHref] = useState(null); // 検索用リンク
    const [summary, setSummary] = useState(null); // 概要
    useEffect(() => {
        if (props.isShow === true) {
            const api =
                "/api/surgeons/summarys/" +
                props.surgeonId +
                "?language=" +
                languageCode;
            fetch(api)
                .then(fnHandleApiErrors)
                .then(fnHandleApiSuccess)
                .then((result) => {
                    if (result !== null) {
                        const surgeon = result[0];
                        const objSurgeonName = {
                            firstName: surgeon.surgeonFirstName,
                            lastName: surgeon.surgeonLastName,
                            middleName: surgeon.surgeonMiddleName,
                        };
                        // モーダルの見出しにするフルネームの執刀医名
                        setFullname(
                            fnGetSurgeonFullName(objSurgeonName, languageCode)
                        );
                        // 所属機関（改行がある場合に備えてTSX Element化）
                        if (surgeon.hospitalName) {
                            const tempHospital = surgeon.hospitalName
                                .replace(/\n/g, "\n<br>\n")
                                .split("\n");
                            const surgeonHospital = tempHospital.map(
                                (text, index) => {
                                    if (text === "<br>") {
                                        return <br key={"br-" + index} />;
                                    } else {
                                        return text;
                                    }
                                }
                            );
                            setHospital(surgeonHospital);
                        }
                        // 検索用リンク
                        setHref(surgeon.searchUrl);
                        // 概要（改行コード変換）
                        if (surgeon.surgeonSummary) {
                            setSummary(
                                fnConvertLineStringToHtml(
                                    surgeon.surgeonSummary
                                )
                            );
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [props.isShow]);

    /**
     * 編集モーダルに渡す処理対象DOMを指定
     */
    const refSummary = useRef(null);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fullname={fullname}
            hospital={hospital}
            href={href}
            languageCode={languageCode}
            refSummary={refSummary}
            summary={summary}
        />
    );
};
